// Service for Register Attendance
import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import type {
  LC_RegisterAttendanceIn,
  LC_RegisterAttendanceOut,
} from '../types';


export class AttendanceRegisterService {
  async register(
    employeeId: number,
    input: LC_RegisterAttendanceIn,
  ): Promise<ApiResponse<LC_RegisterAttendanceOut>> {
    return apiClient.post<LC_RegisterAttendanceOut>(
      API_CONFIG.ENDPOINTS.ATTENDANCE.REGISTER(employeeId),
      input,
    );
  }
}

export const attendanceRegisterService = new AttendanceRegisterService();
